import { css } from '@emotion/css';
import Color from 'styles/colors';
import { Weight } from 'styles/font';

export const selectLocationButton = () => css`
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;

  display: flex;
  align-items: center;

  color: ${Color.Gray[100]};
  gap: 4px;

  &:focus {
    outline: none;
  }
`;

export const rightColumn = css`
  display: flex;
  flex-wrap: nowrap;
`;

export const countNumberRow = () => css`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${Color.Gray[60]};
  padding-left: 20px;
  height: 28px;
  line-height: 24px;
`;

export const infoRow = () => css`
  background: ${Color.Gray[10]};
  min-height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${Color.Gray[60]};
  gap: 4px;
`;

export const informationIcon = () => css`
  width: 8px;
  height: 8px;
`;

export const partnerFormControlLabel = css`
  padding: 1px;
  font-size: 12px;
  margin-right: 2px !important;
  min-width: 76px;

  .MuiTypography-body1 {
    font-size: 12px;
    font-weight: bold;
    color: ${Color.Gray[70]};
  }
`;

export const sortingButton = css`
  @media (max-width: 400px) {
    max-width: 132px;
  }
  .MuiButton-label {
    font-size: 12px;
    font-weight: bold;
    color: #0073fa;
    text-transform: lowercase;
  }

  .MuiButton-endIcon {
    margin-left: 2px;
  }

  :focus {
    outline: unset;
  }
`;

export const scrollableItemsView = css`
  display: flex;
  align-items: center;
  max-width: 100%;
  padding: 0.5rem 1.25rem;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  background-color: white;
  border-bottom: 1px solid #f5f6fa;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  @media (min-width: 480px) {
    flex-wrap: wrap;
  }
`;

export const listHeaderView = css`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 10px 16px 10px 20px;
`;

export const askingAIBanner = (showTopBorder: boolean) => css`
  position: sticky !important;
  top: 0px;
  background-color: ${Color.Green['60']};
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: ${showTopBorder ? `8px solid ${Color.Gray['20']}` : 'unset'};
  border-bottom: 8px solid ${Color.Gray['20']};
  line-height: 0px;
`;

export const askingAIBannerText = css`
  color: ${Color.White};
`;

export const askingAIBannerCTA = css`
  color: ${Color.Green['80']} !important;
  background-color: ${Color.White} !important;
  font-weight: ${Weight.Medium};
  padding: 0 12px 0 13px;
  height: 36px;
`;

export const scrollableChipItem = (selected: boolean) => css`
  font-size: 12px;
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;
  background-color: ${selected ? Color.Gray['100'] : 'transparent'};
  color: ${selected ? Color.White : Color.Gray['70']};
`;

export const scrollableTextItem = (selected: boolean) => css`
  font-size: 12px;
  padding: 0.5rem 0.75rem;
  color: ${selected ? Color.Gray['100'] : Color.Gray['70']};
  font-weight: ${selected ? '700' : '400'};
`;
